<template>
  <nav class="footer-nav">
    <ul class="list-reset">
      <li>
        <router-link to="/document/?N">News</router-link>
      </li>

      <li>
        <router-link to="/document/?H">Documentation</router-link>
      </li>
      <li>
        <router-link to="/contact/">Contact Us</router-link>
      </li>
      <li>
        <div  @mouseenter="setTip($event)" @mouseleave="hiddenTip">&nbsp;&nbsp;&nbsp;&nbsp;一号线手机端</div>
      </li>
    </ul>
  </nav>
</template>

<script>
import Vue from 'vue';
import Vtip from 'vtip'
import 'vtip/lib/index.min.css'
// 注册指令使用
Vue.use(Vtip.directive)
// 工具函数调用
Vue.prototype.$tip = Vtip.tip

var tipContent = {
  template: `
  <div :style="{ width: '170px', height: '200px'}">
    <div style="margin-left: 10px;"><img width="150" height="150" :src="link"/></div>
    <h6 style="margin-left:10px;">扫一扫 关注公众号</h6>
  </div>`,
  computed: {
    link () {
      return require('@/assets/images/lineone.jpg')
    }
  }
}

export default {
  name: "CFooterNav",
  methods: {
    // 工具函数使用
    setTip ({ target }) {
      this.tipInstance = this.$tip({
        target,
        width: 'auto',
        transition: true,
        customComponent: tipContent
      })
    },
    
    hiddenTip ({ target }) {
      const { tipInstance } = this
      if (tipInstance && tipInstance.target === target) {
        tipInstance.hiddenTip()
      }
    }
  }
};
</script>
